import { cn } from '@/lib/utils'
import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import SectionHead from '@/v2/components/sections/landing-pages/section-head'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

interface KeyFactorsSectionProps {
  title: string
  description?: string
  cards: CardType[]
  className?: string
  imgClassName?: string
  isBgDark?: boolean
  sectionTitleClassName?: string
}

const KeyFactorsSection: React.FC<KeyFactorsSectionProps> = props => {
  const { title, description, cards, className, isBgDark = false, imgClassName, sectionTitleClassName } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.section className={cn('landing-pages-wr section-spacing', isBgDark ? 'bg-[#F9F8F8]' : '', className)}>
        <SectionWrapper>
          <SectionHead title={title} description={description} className={sectionTitleClassName} />

          <div className={cn('flex flex-col gap-[24px]')}>
            {cards.map((card, index) => (
              <m.article
                key={card.id}
                className='flex items-center gap-[20px] transition-all h-full'
                initial='hidden'
                whileInView='visible'
                viewport={{ once: false, amount: 0.3 }}
                transition={{
                  delay: index * 0.1,
                  duration: 0.6
                }}
              >
                {card.image && (
                  <div className='self-start sm:self-center'>
                    <ResponsiveImage
                      src={card.image.src}
                      alt={card.image.alt}
                      className={cn('h-[80px] w-[80px]', imgClassName)}
                    />
                  </div>
                )}

                <div className='[&>h3]:font-semibold xl-min:[&>h3]:text-[20px] [&>h3]:w-full sm:[&>h3]:mb-3 [&>h3]:mb-2 [&>h3]:text-[18px] [&>h3]:text-paragraph'>
                  <h3>{card.title}</h3>
                  <p className='text-paragraph leading-6 font-normal text-base '>{card.description}</p>
                </div>
              </m.article>
            ))}
          </div>
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}

export default KeyFactorsSection
